import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'react-bootstrap';
import { isBlank } from 'helpers/string_helpers';

export default function TaskFormErrors({ errors }) {
  if (isBlank(errors)) return null;

  let messages = null;

  if (Array.isArray(errors)) {
    messages = errors.map((error, i) => <li key={i}>{error}</li>);
  }

  return (
    <Alert bsStyle="danger" name="errors-alert">
      <h4><strong>Whoops -</strong> There were errors in the form that prevented saving.</h4>
      <ul>{messages}</ul>
    </Alert>
  );
}

TaskFormErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string)
};
